import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SYNC_ENDPOINTS } from 'actions/Types';

/**
 * Syncs the endpoints in a given program session between all directors.
 */
export default () => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_SYNC_ENDPOINTS,
      request: async apiClient => {
        return await apiClient.broadcast.get(teamId, eventId, broadcastId);
      }
    };
    dispatch(action);
  });
};
